// extracted by mini-css-extract-plugin
module.exports = {"page":"ProjectsPage_page__2kAVh","projects":"ProjectsPage_projects__4_XmO"};